import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@repo/i18n';
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from '@repo/mui-config/theme';
import { MainContextProvider } from '@repo/app-contexts/main';
import { PromotionVariantContextProvider } from '@repo/app-contexts/promotion';
import { LiberisContextProvider } from '@repo/app-contexts/liberis';
import { ErrorBoundary } from './components/error-boundary';
var queryClient = new QueryClient();
var themes = createTheme(theme);
themes = responsiveFontSizes(themes);
export function Providers(_a) {
    var children = _a.children;
    return (_jsxs(ThemeProvider, { theme: themes, children: [_jsx(CssBaseline, {}), _jsx(ErrorBoundary, { children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(MainContextProvider, { children: _jsx(PromotionVariantContextProvider, { children: _jsx(LiberisContextProvider, { children: children }) }) }) }) })] }));
}
